import request from '@/service/index'
export function getCode(){
    return request({
        url:'/captchaImage',
        method:'get'
    })
}
//手机验证注册
export function registerByPhone(data){
    return request({
        url:'/registerByPhone',
        method:'post',
        data:data
    })
}
//发送短信验证码
export function pusuhPhoneCode(params){
    return request({
        url:'/captchaPhone',
        method:'get',
        params:params
    })
}
//忘记密码
export function forgetPassword(data){
    return request({
        url:'/forgotPassword',
        method:'post',
        data
    })
}
export function imgList(){
    return request({
        url:'/music/banner/salesman',
        method:'get'
    })
}
export function getLoginImg(){
    return request({
        url:'/music/banner/loginPagePic',
        method:'get'
    })
}